import React from 'react'
import {
    Switch,
    Route
} from 'react-router-dom';

import NotFound from './components/notFound'
import Home from './components/home'
import BlogDetails from './components/blogDetails'
import ListBlogs from './components/listBlogs'
import Page from './components/page'
import Offer from './components/offer'

import LoginForm from './components/user/login'
import RegisterForm from './components/user/register'
import Reward from './components/user/reward'
import MainPage from './components/mainPage'
export default function RouteConfig() {
    return (
        <Switch>
            <Route exact path="/*" component={MainPage} />
            <Route exact path="/blog/category/:slug" component={ListBlogs} />
            <Route exact path="/blog" component={ListBlogs} />
            <Route exact path="/not-found" component={NotFound} />
            <Route exact path="/pages/:slug" component={Page} />
            <Route exact path="/offers" component={Offer} />
            <Route exact path="/register" component={RegisterForm} />
            <Route exact path="/main" component={MainPage} />
        </Switch>
    )
}


// WEBPACK FOOTER //
// ./src/AppRoutes.js